// ======================================================================
// File Name       : ServiceRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import moment from 'moment';
import React from 'react';
import { Button, Col, Form, FormControl, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getStructure } from '../../actions/EnterpriseAction';
import {
  initializeVideoSpeedOptions,
  serviceEdit,
  serviceSearch,
  updateVideoSpeedUsage,
} from '../../actions/ServiceAction';
import DateTimeWithValidate from '../../components/DateTimeWithValidate';
import DialogConfirm from '../../components/DialogConfirm';
import DialogMessageUsageSettingSufCustomize from '../../components/DialogMessageUsageSettingSufCustomize';
import SelectEnterPriseDlg from '../../components/EnterpriseSelection';
import FormControlValidate from '../../components/FormControlValidate';
import Header from '../../components/Header';
import SelectBox from '../../components/SelectBox';
import ServiceRegisterEditConfirm from '../../components/service/ServiceRegisterEditConfirm';
import ServiceUsageSetting from '../../components/service/ServiceUsageSetting';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { SERVICE_LIST } from '../../constants/PathConstants';
import * as ServiceConstant from '../../constants/ServiceConstant';
import { USER_TYPE } from '../../constants/UserConstants';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_SHORT_FORMAT_SERVER,
  DEFAULT_SELECTED_VIDEO_SPEED_LIST,
  DEFAULT_VIDEO_SPEED_LIST,
  HYPHEN,
  MODAL_SIZE,
  MODE,
  PASS_STRENGTH_TYPE,
  SELECT_TARGET_DATA,
  USAGE_SETTING,
  VALIDATE_TYPE,
  NEW_SERVICE_MANAGEMENT_URL,
} from '../../constants/index';
import * as utils from '../../utils';
import { getEnterprisePath } from '../../utils/EnterPriseUtils';
import { hideLoading, showLoading } from '../../utils/PageUtils';
import { getServiceDeleteFlagLabel } from '../../utils/ServiceUtils';
import { getItemBoxName, getSettingUsageLabel } from '../../utils/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class ServiceRegisterEditContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: MODE.NEW_MODE,
      service: {
        serviceCd: '',
        serviceType: 0,
        serviceName: '',
        enterpriseInfo: {
          enterpriseCd: props.enterpriseCd || '',
          enterpriseName: '',
        },
        domainName: '',
        passwordStrength: PASS_STRENGTH_TYPE.WEAK,
        remark: '',
        dormantState: 0,
        usageSettingInfo: {
          usageSettingLive: USAGE_SETTING.UN_USE, //STEP 12.1.0 TAS-16386
          numberOfChannels: '',
          usageSettingVideo: USAGE_SETTING.USE,
          apiAuthKey: '',
          bitRateSetting: '',
          usageSettingDrill: USAGE_SETTING.USE,
          usageSettingDocument: USAGE_SETTING.USE,
          usageSettingLrs: USAGE_SETTING.USE,
          usageSettingSufCustomize: 0,
          videoMcJobtemplate: '',
          videoSpeedSetting: [],
          isInit: true,
          // Step SAML START
          usageSettingSaml: USAGE_SETTING.UN_USE,
          errorRedirectUrl: '',
          loginSuccessRedirectUrl: '',
          logoutSuccessRedirectUrl: '',
          idpMetadataFile: '',
          // Step SAML END
        },
        serviceCategory: '',
        serviceStartDate: '',
        adminUiCustomize: '',
        ipRestriction: '',
        documentPrintingPermission: '',
        documentDownloadPermission: '', 
        personalSettingsEditDisplay: '',
        progressStatusDisplay: '',
        learningHistoryDisplay: '',
        // Step 10.0.0 START
        helpDisplay: '',
        noticeDisplay: '',
        messageDisplay: '',
        // Step 10.0.0 END
        passwordResetMessageDisplay: '',
        videoForwardingProhibited: '',
        videoEndThreshold: 0, // STEP13.0.0 TAS-21617
        privacyPolicyDisplay: '',
        // Step10.0.0 START
        mfaUsageFlag: '',
        // Step10.0.0 END
        backgroundVideoPlaybackFlag: '', // STEP12.0.0 TAS-18197
      },
      adminInfo: {
        loginId: '',
        pass: '',
        userName: '',
        authoritySecernId: '',
      },
      showModalEnterprise: false,
      showModalConfirm: false,
      showAboutDialog: false,
      enterpriseList: [],
      showModalMessageUsageSettingSufCustomize: false,
      isDisableByCustomizeSuf: false, // STEP13.0.0 TAS-21617
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeForUsageSetting = this.handleChangeForUsageSetting.bind(this);
    this.showEnterpriseDialog = this.showEnterpriseDialog.bind(this);
    this.okEnterprise = this.okEnterprise.bind(this);
    this.cancelEnterprise = this.cancelEnterprise.bind(this);
    this.openPasswordAboutDialog = this.openPasswordAboutDialog.bind(this);
    this.onPasswordAboutOk = this.onPasswordAboutOk.bind(this);
    this.openRegistUpdateConfirmDialog = this.openRegistUpdateConfirmDialog.bind(this);
    this.onRegistUpdateOk = this.onRegistUpdateOk.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onRegistUpdateCancel = this.onRegistUpdateCancel.bind(this);
    this.showModalMessageUsageSettingSufCustomize = this.showModalMessageUsageSettingSufCustomize.bind(this);
    this.okModalMessageUsageSettingSufCustomize = this.okModalMessageUsageSettingSufCustomize.bind(this);
    this.handleVideoSpeedSettingChange = this.handleVideoSpeedSettingChange.bind(this);
    this.handleUseVideoSpeed = this.handleUseVideoSpeed.bind(this);
    this.handleResetCheckbox = this.handleResetCheckbox.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this); // Step SAML
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleChangeForServiceSetting = this.handleChangeForServiceSetting.bind(this);
    this.handleChangeForVideoEndThreshold = this.handleChangeForVideoEndThreshold.bind(this); // STEP13.0.0 TAS-21617
  }

  /**
   * Life cycle function
   */
  componentWillMount() {
    const { match } = this.props;
    const { service } = this.state;
    if (match.params.id) {
      const param = {
        selectTargetData: SELECT_TARGET_DATA.DATA,
        searchInfo: {
          serviceCdList: [match.params.id],
        },
      };
      this.props.dispatch(serviceSearch(param));
    } else {
      if (service.usageSettingInfo.isInit) {
        this.handleResetCheckbox(service.usageSettingInfo.isInit);
        this.props.dispatch(updateVideoSpeedUsage(true));
      } else {
        this.handleResetCheckbox();
        this.props.dispatch(updateVideoSpeedUsage(false));
      }
      this.getEnterpriseList();
    }
  }

  /**
   * Life cycle function
   */
  componentWillReceiveProps(nextProps) {
    const { service, match, enterpriseStructure, videoSpeedArr } = nextProps;
    if (match.params.id && service) {
      const { serviceInfo } = service;
      const serviceDetail = $.grep(serviceInfo.serviceList, e => e.serviceCd === match.params.id);
      if (serviceDetail.length > 0) {
        // Step SAML START
        const { domainName } = serviceDetail[0];
        // Step SAML END
        // #5678
        if (parseInt(this.props.displayUserType, 10) === USER_TYPE.ADMIN) {
          const { videoSpeedSetting, videoMcJobtemplate } = serviceInfo.serviceList[0].usageSettingInfo;
          let videoSpeedSettingResult = [];
          if (!Array.isArray(videoSpeedSetting)) {
            videoSpeedSettingResult = videoSpeedSetting ? videoSpeedSetting.split(HYPHEN) : [];
          } else {
            videoSpeedSettingResult = videoSpeedSetting;
          }
          videoSpeedArr.map((value) => {
            if (parseInt(videoSpeedSettingResult.indexOf(value.speed), 10) < 0 &&
              value.isChecked && !DEFAULT_VIDEO_SPEED_LIST.includes(value.speed)) {
              videoSpeedSettingResult.push(value.speed);
            }
            if (!value.isChecked) {
              videoSpeedSettingResult.splice(videoSpeedSettingResult.indexOf(value.speed), 1);
            }
          });
          serviceDetail[0].usageSettingInfo.videoSpeedSetting = videoSpeedSettingResult.join(HYPHEN);
          serviceDetail[0].usageSettingInfo.videoMcJobtemplate = videoMcJobtemplate;
        }
        serviceDetail[0].enterpriseInfo = {
          enterpriseCd: serviceDetail[0].enterpriseCd,
          enterpriseName: serviceDetail[0].enterpriseName,
          usageSettingInfo: { ...this.state.service.usageSettingInfo },
        };
        // Step SAML START
        if (!serviceDetail[0].usageSettingInfo.loginSuccessRedirectUrl) {
          serviceDetail[0].usageSettingInfo.loginSuccessRedirectUrl =
            ServiceConstant.SAML_SERVICE_SETTING.LOGIN_SUCCESS_REDIRECT_URL.replace(':domainName', domainName);
        }
        if (!serviceDetail[0].usageSettingInfo.logoutSuccessRedirectUrl) {
          serviceDetail[0].usageSettingInfo.logoutSuccessRedirectUrl =
            ServiceConstant.SAML_SERVICE_SETTING.LOGOUT_SUCCESS_REDIRECT_URL.replace(':domainName', domainName);
        }
        if (!serviceDetail[0].usageSettingInfo.errorRedirectUrl) {
          serviceDetail[0].usageSettingInfo.errorRedirectUrl =
            ServiceConstant.SAML_SERVICE_SETTING.ERROR_REDIRECT_URL.replace(':domainName', domainName);
        }
        // STEP SAML END
        this.setState({
          mode: MODE.EDIT_MODE,
          service: serviceDetail[0],
          enterpriseList: enterpriseStructure,
          isDisableByCustomizeSuf: serviceDetail[0].usageSettingInfo.usageSettingSufCustomize === 1,
        });
      }
    } else {
      this.setState({
        enterpriseList: enterpriseStructure,
      });
    }
  }
  componentWillUnmount() {
    this.handleResetCheckbox();
    this.props.dispatch(updateVideoSpeedUsage(false));
  }

  handleResetCheckbox(isInit) {
    const { videoSpeedArr } = this.props.service;
    const videoSpeedArrUpdate = videoSpeedArr.map((val) => {
      const obj = {};
      obj.speed = val.speed;
      obj.isChecked = isInit ? DEFAULT_VIDEO_SPEED_LIST.includes(val.speed) : DEFAULT_SELECTED_VIDEO_SPEED_LIST.includes(val.speed);
      return obj;
    });
    this.props.dispatch(initializeVideoSpeedOptions(videoSpeedArrUpdate));
  }
  /**
   * Open dialog regist update confirm dialog
   */
  openRegistUpdateConfirmDialog() {
    const adminInfo = this.state.adminInfo;
    if (adminInfo.userName === '代表ユーザ' || adminInfo.userName === 'システムユーザ') {
      return;
    }
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
    if (isValid) {
      this.setState({ showModalConfirm: true });
    }
  }

  goBack() {
    this.props.history.goBack();
  }
  /**
   * Event click button ok in confirm dialog
   */
  onRegistUpdateOk() {
    this.setState({
      showModalConfirm: false,
    });
    const { service, mode } = this.state;
    const { isUsedVideoSpeedSetting, videoSpeedArr, serviceInfo } = this.props.service;
    const { displayUserType, rootFlag } = this.props;
    let videoSpeedSettingParam = [];
    videoSpeedArr.map((value) => {
      if (value.isChecked) {
        videoSpeedSettingParam.push(value.speed);
      }
    });
    if (videoSpeedSettingParam.length > 0 && isUsedVideoSpeedSetting) {
      videoSpeedSettingParam = videoSpeedSettingParam.sort().join(HYPHEN);
    } else {
      videoSpeedSettingParam = '';
    }
    const param = {
      editType: mode,
      serviceInfo: {
        serviceCd: service.serviceCd,
        serviceType: mode !== MODE.EDIT_MODE ? parseInt(service.serviceType, 10) : null,
        serviceName: service.serviceName,
        relationEnterpriseCd: mode !== MODE.EDIT_MODE ? service.enterpriseInfo.enterpriseCd : null,
        domainName: service.domainName,
        // sprint_20230403 #11 START
        passwordStrength: parseInt(service.passwordStrength, 10),
        // sprint_20230403 #11 END
        remark: service.remark,
        dormantState: service.dormantState,
        // Step10.0.0 START
        mfaUsageFlag: service.mfaUsageFlag,
        // Step10.0.0 END
        usageSettingInfo: {
          usageSettingLive: USAGE_SETTING.UN_USE, //STEP 12.1.0 TAS-16386
          numberOfChannels: service.usageSettingInfo && service.usageSettingInfo.numberOfChannels !== '' ?
          service.usageSettingInfo.numberOfChannels : null,
          usageSettingVideo: service.usageSettingInfo ? service.usageSettingInfo.usageSettingVideo : null,
          usageSettingDrill: USAGE_SETTING.USE,
          usageSettingDocument: USAGE_SETTING.USE,
          videoSpeedSetting: videoSpeedSettingParam, // sprint_20230403 #5
          videoMcJobtemplate: displayUserType === USER_TYPE.ADMIN ? service.usageSettingInfo.videoMcJobtemplate : null,
          usageSettingLrs: USAGE_SETTING.USE,
          usageSettingSufCustomize: service.usageSettingInfo ? service.usageSettingInfo.usageSettingSufCustomize : null,
          usageSettingSaml: mode === MODE.EDIT_MODE ? parseInt(service.usageSettingInfo.usageSettingSaml, 10) : USAGE_SETTING.UN_USE, // Step SAML
        },
      },
    };

    // Step SAML START
    if (service.usageSettingInfo && parseInt(service.usageSettingInfo.usageSettingSaml, 10) === USAGE_SETTING.USE) {
      const { usageSettingInfo } = param.serviceInfo;
      usageSettingInfo.errorRedirectUrl = service.usageSettingInfo.errorRedirectUrl;
      usageSettingInfo.loginSuccessRedirectUrl = service.usageSettingInfo.loginSuccessRedirectUrl;
      usageSettingInfo.logoutSuccessRedirectUrl = service.usageSettingInfo.logoutSuccessRedirectUrl;
      if (this.state.dataUrl) {
        usageSettingInfo.idpMetadataFile = this.state.dataUrl;
      }
    }
    // Step SAML END
    // sprint_20230403 #4 START
    if (mode === MODE.EDIT_MODE) {
      const { serviceInfo } = param;
      // STEP13.0.0 TAS-23260 START
      const isNotSufCustomize = service.usageSettingInfo.usageSettingSufCustomize !== 1;
      const commonPermissionProps = [
        'documentPrintingPermission',
        'documentDownloadPermission',
        'personalSettingsEditDisplay',
        'progressStatusDisplay',
        'learningHistoryDisplay',
        'messageDisplay',
        'passwordResetMessageDisplay',
        'videoForwardingProhibited',
        'backgroundVideoPlaybackFlag'
      ];

      if (displayUserType === USER_TYPE.ADMIN) {
        Object.assign(serviceInfo, {
          serviceCategory: service.serviceCategory,
          serviceStartDate: service.serviceStartDate ? moment(service.serviceStartDate).format(DEFAULT_DATE_SHORT_FORMAT_SERVER) : '',
          adminUiCustomize: service.adminUiCustomize,
          ipRestriction: service.ipRestriction,
          helpDisplay: service.helpDisplay, // Step 10.0.0
          noticeDisplay: service.noticeDisplay, // Step 10.0.0
          privacyPolicyDisplay: service.privacyPolicyDisplay, // Step 8.0.3
          customizeRange: service.customizeRange,
          dormantUserDataAcquisitionPermissionFlag: service.dormantUserDataAcquisitionPermissionFlag, // sprint_20230508 #27
          mfaUsageFlag: service.mfaUsageFlag, // Step 10.0.0
          videoEndThreshold: service.videoEndThreshold // Step 13.0.0 TAS-21617
        });

        if (isNotSufCustomize) {
          commonPermissionProps.forEach(key => {
            serviceInfo[key] = service[key];
          });
        }
      }

      if (rootFlag) {
        if (isNotSufCustomize) {
          commonPermissionProps.forEach(key => {
            serviceInfo[key] = service[key];
          });
        }
        serviceInfo.videoEndThreshold = service.videoEndThreshold;
      }
      // STEP13.0.0 TAS-23260 END
    }
    // sprint_20230403 #4 END
    const { history } = this.props;
    this.props.dispatch(showLoading());
    this.props.dispatch(serviceEdit(param)).then(() => {
      // Back to service top
      this.props.dispatch(hideLoading());
      // STEP12.0.0 TAS-18904 START
      window.location.href = NEW_SERVICE_MANAGEMENT_URL;
      // STEP12.0.0 TAS-18904 END
    });
  }

  /**
   * Event click button cancel in confirm dialog
   */
  onRegistUpdateCancel() {
    this.setState({
      showModalConfirm: false,
    });
  }

  /**
   * Show enterprise dialog
   */
  showEnterpriseDialog() {
    this.setState({
      showModalEnterprise: true,
    });
  }

  /**
   * Event click button ok in enterprise dialog
   * @param {*} data
   */
  okEnterprise(data) {
    if (!data.enterpriseCd) {
      this.setState({
        showModalEnterprise: false,
      });
      return;
    }
    const serviceInfo = this.state.service;
    serviceInfo.enterpriseInfo.enterpriseCd = data.enterpriseCd;
    serviceInfo.enterpriseInfo.enterpriseName = data.enterpriseName;
    this.setState({
      showModalEnterprise: false,
      service: serviceInfo,
    });
  }

  /**
   * Event click button cancel in enterprise dialog
   */
  cancelEnterprise() {
    this.setState({
      showModalEnterprise: false,
    });
  }

  /**
     * Get enterprise list
     */
  getEnterpriseList() {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    this.props.dispatch(getStructure(param));
  }

  /**
     * Show more information when click
     */
  openPasswordAboutDialog() {
    this.setState({ showAboutDialog: true });
  }

  onPasswordAboutOk() {
    this.setState({ showAboutDialog: false });
  }

  /**
     * handle change user input
     * @param {*} event
     */
  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    const serviceInfo = this.state.service;
    serviceInfo[name] = value;
    if (name === 'serviceType' && parseInt(value, 10) === 2) {
      serviceInfo.passwordStrength = PASS_STRENGTH_TYPE.STRONG;
      serviceInfo.usageSettingInfo.usageSettingVideo = USAGE_SETTING.USE;
      serviceInfo.usageSettingInfo.usageSettingLive = USAGE_SETTING.UN_USE; // live is set to 0
      serviceInfo.usageSettingInfo.usageSettingDrill = USAGE_SETTING.USE;
      serviceInfo.usageSettingInfo.usageSettingDocument = USAGE_SETTING.USE;
      serviceInfo.usageSettingInfo.usageSettingLrs = USAGE_SETTING.USE;
      serviceInfo.dormantState = 0;
    }
    if (name === 'usageSettingSufCustomize') {
      const checked = event.target.checked ? 1 : 0;
      serviceInfo.usageSettingInfo.usageSettingSufCustomize = checked;
      // STEP7.0 #3 START
      /**
      if (checked === 1) {
        this.showModalMessageUsageSettingSufCustomize();
      } */
      // STEP7.0 #3 END
      this.setState({ isDisableByCustomizeSuf: event.target.checked }); // STEP13.0.0 TAS-21617
    }
    // sprint_20230403 #4 START
    if (name === 'serviceCategory') {
      serviceInfo[name] = Number.parseInt(value, 10);
    }
    // sprint_20230403 #4 END
    this.setState({ service: serviceInfo });
  }
  // handle select box
  handleUseVideoSpeed(event) {
    const isUsedVideoSpeedSetting = parseInt(event.target.value, 10) ===
    ServiceConstant.AVAILABLE_DISABLE_USAGE.AVAILABLE;
    const name = event.target.name;
    let { videoSpeedSetting } = this.state.service.usageSettingInfo;
    const videoSpeedArrUpdate = [...this.props.videoSpeedArr];

    if (isUsedVideoSpeedSetting) {
      videoSpeedSetting.push(DEFAULT_VIDEO_SPEED_LIST);

      videoSpeedArrUpdate.map((speedSetting) => {
        if (DEFAULT_VIDEO_SPEED_LIST.includes(speedSetting.speed)) {
          speedSetting.isChecked = true;
        }
      });
    } else {
      videoSpeedSetting = [];
      videoSpeedArrUpdate.map((speedSetting) => {
        if (!DEFAULT_VIDEO_SPEED_LIST.includes(speedSetting.speed)) {
          speedSetting.isChecked = false;
        }
      });
    }

    const serviceInfo = this.state.service;
    serviceInfo.usageSettingInfo[name] = videoSpeedSetting;
    serviceInfo.usageSettingInfo.isInit = false;
    this.state.isUsedVideoSpeedSetting = isUsedVideoSpeedSetting;
    this.setState({ service: serviceInfo });

    this.props.dispatch(updateVideoSpeedUsage(isUsedVideoSpeedSetting));
    this.props.dispatch(initializeVideoSpeedOptions(videoSpeedArrUpdate));
  }

  // Handle check box
  handleVideoSpeedSettingChange(event) {
    const value = event.target.value;
    const isChecked = event.target.checked;

    // handle check and uncheck
    let videoSpeedArrUpdate = [];
    videoSpeedArrUpdate = this.props.videoSpeedArr.map((speedSetting) => {
      const videoSpeedObj = {};
      if (speedSetting.speed.toString() === value) {
        speedSetting.isChecked = isChecked;
      }
      videoSpeedObj.speed = speedSetting.speed;
      videoSpeedObj.isChecked = speedSetting.isChecked;
      return videoSpeedObj;
    });
    this.props.dispatch(initializeVideoSpeedOptions(videoSpeedArrUpdate));
  }

  showModalMessageUsageSettingSufCustomize() {
    this.setState({ showModalMessageUsageSettingSufCustomize: true });
  }

  okModalMessageUsageSettingSufCustomize() {
    this.setState({ showModalMessageUsageSettingSufCustomize: false });
  }
  /**
     * handle change for Usage Setting input
     * @param {*} event
     */
  handleChangeForUsageSetting(event) {
    const paramName = event.target.name;
    const serviceInfo = this.state.service;
    serviceInfo.usageSettingInfo[paramName] = event.target.value;
    this.setState({ service: serviceInfo });
  }

  // Step SAML START
  handleFileChange(event) {
    try {
      if (event.target.files && event.target.files.length !== 0) {
        const reader = new FileReader();
        const xmlUploadFileName = event.target.files[0].name;
        const xmlUploadFile = event.target.files[0];
        this.setState({
          xmlUploadFile,
          xmlUploadFileName,
        });
        reader.readAsDataURL(xmlUploadFile);
        reader.onload = () => {
          // Get base64 encoded string
          const dataUrl = reader.result.replace('data:', '').replace(/^.+,/, '');
          this.setState({
            dataUrl,
          });
        };
      }
    } catch (err) {
      console.log(err);
    }
  }
  // Step SAML END

  // sprint_20230403 #4 START
  handleTimeChange(name, value) {
    // update 利用開始日
    const serviceInfo = this.state.service;
    serviceInfo[name] = value;
    this.setState({ service: serviceInfo });
  }

  handleChangeForServiceSetting(event) {
    const paramName = event.target.name;
    const serviceInfo = this.state.service;
    serviceInfo[paramName] = event.target.value === 'true';
    this.setState({ service: serviceInfo });
  }
  // sprint_20230403 #4 END

  // STEP13.0.0 TAS-21617 START
  handleChangeForVideoEndThreshold(name, value) {
    const serviceInfo = this.state.service;
    serviceInfo[name] = parseInt(value, 10);
    this.setState({ service: serviceInfo });
  }
  // STEP13.0.0 TAS-21617 END

  /**
   * Render function of component
   */
  render() {
    const isNewMode = this.state.mode === MODE.NEW_MODE;
    const { enterpriseCd, service, enterpriseList } = this.state;
    const { videoSpeedArr, displayUserType } = this.props;
    const videoComfirmation = [];
    videoSpeedArr.map((value) => {
      if (value.isChecked) {
        videoComfirmation.push(value.speed);
      }
    });

    this.refsToValidate = [];

    const usageSettingCertificate = service.usageSettingInfo.certificateUsageFlag ? USAGE_SETTING.USE : USAGE_SETTING.UN_USE;
    // #7494 START
    const isContentDistributionService = parseInt(service.serviceType, 10) === 2;
    // #7494 END
    const isSupperUserL0 = parseInt(displayUserType, 10) === USER_TYPE.ADMIN;
    return (
      <div>
        { isNewMode && (
          <CustomLink
            className="margin-right-7 url-list"
            to={Path.SERVICE_LIST}
            text="サービス一覧に戻る"
            icon="bi bi-chevron-left"
          />
        )}
        <Header name={isNewMode ? 'サービス情報の新規登録' : 'サービス情報の編集'} />
        <p className="margin-top-10">
          {isNewMode ? '登録する項目を指定してください' : '編集する項目を指定してください'}
        </p>
        <Form onSubmit={(e) => { e.preventDefault(); this.openRegistUpdateConfirmDialog(); }} className='form-horizontal'>
          <Row className="margin-top-10 padding-left-15 padding-right-15">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                所属企業名
                {isNewMode && <span className="required">&nbsp;(※)</span>}
              </Col>
              <Col sm={1}>
                {isNewMode &&
                  <Button variant="primary" onClick={this.showEnterpriseDialog}>
                    選択
                  </Button>}
              </Col>
              <Col sm={7} as={Form.Label} className="ps-0">
                <FormControlValidate
                  label="所属企業名"
                  validateType={VALIDATE_TYPE.LABEL}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required={isNewMode}
                  value={getEnterprisePath(service.enterpriseInfo, enterpriseList) || ''}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label} >サービス種別</Col>
              {isNewMode
                ? <Col sm={8}>
                  <Col sm={5} className="padding-left-right-clear padding-top-10">
                    <Form.Check
                      type='radio'
                      inline
                      className="padding-top-clear"
                      name="serviceType"
                      id="serviceType-0"
                      value="0"
                      onChange={this.handleChange}
                      checked={parseInt(service.serviceType, 10) === 0}
                      label='通常サービス'></Form.Check>
                  </Col>
                  <Col sm={7} className="padding-left-right-clear padding-top-10">
                    <Form.Check
                      type='radio'
                      inline
                      className="padding-top-clear"
                      name="serviceType"
                      id="serviceType-2"
                      value="2"
                      onChange={this.handleChange}
                      checked={parseInt(service.serviceType, 10) === 2}
                      label='コンテンツ配信サービス'></Form.Check>
                  </Col>
                </Col>
                : <Col sm={8} className="lable-value ps-0" as={Form.Label} >
                  {getItemBoxName(ServiceConstant.ServiceType, service.serviceType)}
                </Col>}
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                サービス名
                <span className="required">&nbsp;(※)</span>
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  label="サービス名"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                  name="serviceName"
                  value={service.serviceName}
                  onChange={this.handleChange}
                  type="text"
                  maxLength="256"
                />
              </Col>
            </Form.Group>
            {isNewMode
              ? <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  サービスコード
                  <span className="required">&nbsp;(※)</span>
                </Col>
                <Col sm={7}>
                  <FormControlValidate
                    label="サービスコード"
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    required
                    type="text"
                    name="serviceCd"
                    maxLength="256"
                    // sprint_20230403 #6 START
                    validateType={VALIDATE_TYPE.ID_INCLUDING_HYPHEN}
                    // sprint_20230403 #6 END
                    onChange={this.handleChange}
                    value={service.serviceCd}
                  />
                </Col>
              </Form.Group>
              : <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  サービスコード
                </Col>
                <Col sm={7} className="lable-value ps-0" as={Form.Label} >
                  {service.serviceCd}
                </Col>
              </Form.Group>}
            {isNewMode ? <Form.Group className="form-info">
              <Col as={Form.Label} sm={4} className="padding-right-clear">
                サービス利用ユーザーサイトドメイン
              </Col>
              <Col sm={7}>
                <Col sm={1} className="padding-left-clear text-right padding-top-10">ss-</Col>
                <Col sm={9} className="padding-left-right-clear">
                  <FormControl
                    name="domainName"
                    value={service.domainName}
                    onChange={this.handleChange}
                    type="text"
                    maxLength="242"
                  />
                </Col>
                <Col sm={2} className="padding-left-right-clear padding-top-10">.l-cloud.jp</Col>
              </Col>
            </Form.Group>
              : <Form.Group className="form-info">
                <Col as={Form.Label} sm={4} className="padding-right-clear">
                  サービス利用ユーザーサイトドメイン
                </Col>
                <Col sm={8} className="lable-value ps-0" as={Form.Label} >
                  {`ss-${service.domainName}.l-cloud.jp`}
                </Col>
              </Form.Group>}
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                パスワード強度
              </Col>
              {/* // sprint_20230403 #11 START */}
              <Col sm={7} className="padding-top-10">
                  <Col sm={4} className="padding-left-right-clear">
                    <Form.Check
                      type='radio'
                      inline
                      className="padding-top-clear"
                      name="passwordStrength"
                      id={`passwordStrength-${PASS_STRENGTH_TYPE.WEAK}`}
                      value={PASS_STRENGTH_TYPE.WEAK}
                      onChange={this.handleChange}
                      checked={parseInt(service.passwordStrength, 10) === PASS_STRENGTH_TYPE.WEAK}
                      disabled={parseInt(service.serviceType, 10) === 2}
                      label='標準'></Form.Check>
                  </Col>
                  <Col sm={4}>
                    <Form.Check
                      type='radio'
                      inline
                      className="padding-top-clear"
                      name="passwordStrength"
                      id={`passwordStrength-${PASS_STRENGTH_TYPE.MEDIUM}`}
                      value={PASS_STRENGTH_TYPE.MEDIUM}
                      onChange={this.handleChange}
                      checked={parseInt(service.passwordStrength, 10) === PASS_STRENGTH_TYPE.MEDIUM}
                      disabled={parseInt(service.serviceType, 10) === 2}
                      label='中'></Form.Check>
                  </Col>
                  <Col sm={4}>
                    <Form.Check
                      type='radio'
                      inline
                      className="padding-top-clear"
                      name="passwordStrength"
                      id={`passwordStrength-${PASS_STRENGTH_TYPE.STRONG}`}
                      value={PASS_STRENGTH_TYPE.STRONG}
                      onChange={this.handleChange}
                      checked={parseInt(service.passwordStrength, 10) === PASS_STRENGTH_TYPE.STRONG}
                      disabled={parseInt(service.serviceType, 10) === 2}
                      label='強'></Form.Check>
                  </Col>
              </Col>
              {/* // sprint_20230403 #11 END */}
            </Form.Group>
            {/* // Step SAML START */}
            {!isNewMode && !isContentDistributionService && (
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={4}>
                  クライアント証明書認証
                </Col>
                <Col sm={7} className="lable-value ps-0" as={Form.Label}>
                  {getSettingUsageLabel(usageSettingCertificate)}
                </Col>
              </Form.Group>
            )}
            {/* // Step SAML END */}
            {isNewMode
              ? <Form.Group className="form-info">
                <Col sm={12} className="padding-left-15">
                  <Button
                    variant="link"
                    onClick={this.openPasswordAboutDialog}
                  >
                    パスワード強度について
                  </Button>
                </Col>
              </Form.Group>
              : null}
            {/* Step10.0.0 START */}
            {!isNewMode && !isContentDistributionService && (
              <Form.Group className="form-info label-middle">
                <Col as={Form.Label} sm={4} >
                  MFA認証
                </Col>
                <Col sm={7}>
                  <SelectBox
                    name="mfaUsageFlag"
                    onChange={this.handleChangeForServiceSetting}
                    data={SELECT_BOX_DATA.AVAILABLE_DISABLE_USAGE_BOOLEAN_VALUE}
                    parse={(value) => value === 'true'}
                    value={service.mfaUsageFlag}
                  />
                </Col>
              </Form.Group>
            )}
            {/* Step10.0.0 END */}
            <Form.Group className="form-info label-middle" controlId="remark">
              <Col as={Form.Label} sm={4}>
                備考
              </Col>
              <Col className="padding-bottom-10" sm={7}>
                <FormControl
                  as="textarea"
                  className="textArea"
                  name="remark"
                  onChange={this.handleChange}
                  value={service.remark || ''}
                  maxLength="256"
                />
              </Col>
            </Form.Group>

            {/* sprint_20230403 #4 START */}
            {isSupperUserL0 && !isNewMode && !isContentDistributionService && (
              <Form.Group className="form-info label-middle" controlId="serviceStartDate">
                <Col as={Form.Label} sm={4}>
                  利用開始日
                </Col>
                <Col sm={7}>
                  <DateTimeWithValidate
                    dateFormat={DEFAULT_DATE_FORMAT}
                    label="利用開始日"
                    value={service.serviceStartDate}
                    onChange={date =>
                      this.handleTimeChange(
                        'serviceStartDate', date,
                      )}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              </Form.Group>
            )}
            {/* sprint_20230403 #4 END */}
            <hr className="break-line" />
            <ServiceUsageSetting
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              usageSettingInfo={service.usageSettingInfo}
              handleChangeForUsageSetting={this.handleChangeForUsageSetting}
              displayUserType={this.props.displayUserType}
              serviceType={service.serviceType}
              handleChange={this.handleChange}
              handleVideoSpeedSettingChange={this.handleVideoSpeedSettingChange}
              handleUseVideoSpeed={this.handleUseVideoSpeed}
              isUsedVideoSpeedSetting={this.props.service.isUsedVideoSpeedSetting}
              videoSpeedArr={videoSpeedArr}
              mode={this.state.mode}
              handleFileChange={this.handleFileChange}
              xmlUploadFile={this.state.xmlUploadFile}
              xmlUploadFileName={this.state.xmlUploadFileName}
              domainName={service.domainName}
              adminUiCustomize={service.adminUiCustomize}
              ipRestriction={service.ipRestriction}
              documentPrintingPermission={service.documentPrintingPermission}
              documentDownloadPermission={service.documentDownloadPermission}
              personalSettingsEditDisplay={service.personalSettingsEditDisplay}
              progressStatusDisplay={service.progressStatusDisplay}
              learningHistoryDisplay={service.learningHistoryDisplay}
              // Step 10.0.0 START
              helpDisplay={service.helpDisplay}
              noticeDisplay={service.noticeDisplay}
              messageDisplay={service.messageDisplay}
              // Step 10.0.0 END
              passwordResetMessageDisplay={service.passwordResetMessageDisplay}
              videoForwardingProhibited={service.videoForwardingProhibited}
              backgroundVideoPlaybackFlag={service.backgroundVideoPlaybackFlag} // STEP12.0.0 TAS-18197
              // Step8.0.3 START
              // STEP13.0.0 TAS-21617 START
              videoEndThreshold={service.videoEndThreshold}
              rootFlag={this.props.rootFlag}
              handleChangeForVideoEndThreshold={this.handleChangeForVideoEndThreshold}
              // STEP13.0.0 TAS-21617 END
              privacyPolicyDisplay={service.privacyPolicyDisplay}
              // Step8.0.3 END
              customizeRange={service.customizeRange}
              // sprint_20230508 #27 START
              dormantUserDataAcquisitionPermissionFlag={service.dormantUserDataAcquisitionPermissionFlag}
              // sprint_20230508 #27 END
              handleChangeForServiceSetting={this.handleChangeForServiceSetting}
              isDisableByCustomizeSuf={this.state.isDisableByCustomizeSuf} // STEP13.0.0 TAS-21617
            />
            <Form.Group className="form-info label-middle">
              <Col as={Form.Label} sm={4} className="margin-top-10">
                稼働状態
              </Col>
              <Col sm={7}>
                <SelectBox
                  disabled={parseInt(service.serviceType, 10) === 2}
                  name="dormantState"
                  value={service.dormantState}
                  data={ServiceConstant.DormantState}
                  onChange={this.handleChange}
                />
              </Col>
            </Form.Group>
            {/* sprint_20230403 #4 START */}
            {isSupperUserL0 && !isNewMode && !isContentDistributionService && (
              <>
                <Form.Group className="form-info label-middle">
                  <Col sm={4} className="form-label">サービス区分</Col>
                  <Col sm={7}>
                    <SelectBox
                      disabled={parseInt(service.serviceType, 10) === 2}
                      name="serviceCategory"
                      value={service.serviceCategory}
                      data={SELECT_BOX_DATA.SERVICE_CATEGORY}
                      onChange={this.handleChange}
                    />
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={4} className="form-label">解約フラグ</Col>
                  <Col sm={7} className="form-label ps-0">
                    {getServiceDeleteFlagLabel(service.serviceDeleteFlag)}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={4} className="form-label">解約予定日</Col>
                  <Col sm={7} className="form-label">
                    {utils.parseDateForDetail(service.serviceDeleteDate, DEFAULT_DATE_FORMAT)}
                  </Col>
                </Form.Group>
              </>
            )}
            {/* sprint_20230403 #4 END */}
            <Form.Group className="margin-top-50 text-center">
              <Col sm={12} className="text-center margin-bottom-10">
                {!isNewMode &&
                  <Button variant="default" className="btn btn-96" role="button" onClick={this.goBack}>
                    キャンセル
                  </Button>}
                <Button
                  variant="primary"
                  className="margin-left-10 margin-right-10 btn-96"
                  type="submit"
                >
                  OK
                </Button>
              </Col>
            </Form.Group>
          </Row>
        </Form>
        <SelectEnterPriseDlg
          showModal={this.state.showModalEnterprise}
          enterpriseList={this.state.enterpriseList}
          selectedEnterprise={service.enterpriseInfo}
          onCancel={this.cancelEnterprise}
          onOK={this.okEnterprise}
          currentEnterpriseCd={enterpriseCd}
        />
        <ServiceRegisterEditConfirm
          showModal={this.state.showModalConfirm}
          size={MODAL_SIZE.lg}
          service={service}
          onRegisterEditOk={this.onRegistUpdateOk}
          onRegisterEditCancel={this.onRegistUpdateCancel}
          enterpriseList={enterpriseList}
          displayUserType={this.props.displayUserType}
          isUsedVideoSpeedSetting={this.props.service.isUsedVideoSpeedSetting}
          videoSpeedSettingConfirmation={videoComfirmation}
          videoMcJobtemplate={this.state.service.usageSettingInfo.videoMcJobtemplate}
          isNewMode={isNewMode}
          xmlUploadFileName={this.state.xmlUploadFileName} // #7498
          rootFlag={this.props.rootFlag} // STEP13.0.0 TAS-21617
        />
        <DialogConfirm
          showModal={this.state.showAboutDialog}
          leftContent
          mdSize={MODAL_SIZE.lg}
          label={MessageTemplate.ABOUT_PASSWORD_STRENGTH_TITLE}
          content={MessageTemplate.ABOUT_PASSWORD_STRENGTH_BODY}
          onOK={this.onPasswordAboutOk}
          className="modal-width-660 padding-left-right-15"
        />
        <DialogMessageUsageSettingSufCustomize
          showModal={this.state.showModalMessageUsageSettingSufCustomize}
          onOK={this.okModalMessageUsageSettingSufCustomize}
          leftContent
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{
    service: state.service,
    enterpriseStructure: state.service.enterpriseList,
    enterpriseCd: state.authed.authedUser.enterpriseCd,
    displayUserType: state.authed.authedUser.userInfo.displayUserType,
    videoSpeedArr: state.service.videoSpeedArr,
    rootFlag : state.authed.authedUser.rootFlag,
  },
});

export default connect(mapStateToProps)(ServiceRegisterEditContainer);
